import { render, staticRenderFns } from "./StepPrizeSetting.vue?vue&type=template&id=340682bd&scoped=true"
import script from "./StepPrizeSetting.vue?vue&type=script&lang=ts"
export * from "./StepPrizeSetting.vue?vue&type=script&lang=ts"
import style0 from "./StepPrizeSetting.vue?vue&type=style&index=0&id=340682bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340682bd",
  null
  
)

export default component.exports